/*
 *
 * File JS componente HEADER
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './header.scss';
import Headroom from 'headroom.js';

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const html = document.querySelector('html');
const body = document.querySelector('body');
const header = document.querySelector('header');
const headerWrap = document.querySelector('header .header-wrap');
const menuContainer = document.querySelector(
    'header .header-wrap .menu-container'
);
const hamburgerBtn = document.querySelector('.header-wrap .burger');

const linksWithSubMenu = document.querySelectorAll(
    'header .header-wrap .main-menu > ul > li.dropdown'
);
const anchorLinksSubMenu = document.querySelectorAll(
    'header .header-wrap .main-menu > ul > li.dropdown > a'
);

let offsetHeader = 40;
let optionsHeadroom = {
    offset: offsetHeader,
};

if (header) {
    let headroom = new Headroom(header, optionsHeadroom);
    headroom.init();
}

/**
 *	Funzione di gestione apertura/chiusura campo search
 *
 *	@return {void}
 */
const manageSearchComponent = () => {
    const btnToggleSearch = header.querySelector('.search-btn');
    const closeSearchMobile = header.querySelector('.close-search');
    const searchWrap = header.querySelector('#searchform');
    const inputSearch = header.querySelector('.wp-block-search__input');
    const iconsWrap = header.querySelector('.woocommerce-menu');

    if (window.innerWidth < 768) {
        btnToggleSearch.addEventListener('click', () => {
            body.classList.add('open-search');
            searchWrap.classList.add('open');
            searchWrap.focus();
        });

        closeSearchMobile.addEventListener('click', () => {
            body.classList.remove('open-search');
            searchWrap.classList.remove('open');
            btnToggleSearch.focus();
        });
    } else {
        return;
    }

    // Controllo URL per verificare se siamo nella pagina di ricerca e aprire il campo di ricerca nell'header
    const url = window.location.href;

    if (url.indexOf('?s=') != -1) {
        btnToggleSearch.click();
    }
};

/**
 *  Funzione di gestione apertura/chiusura menu mobile
 *
 *  @return {void}
 */
const manageMenuMobile = () => {
    hamburgerBtn.addEventListener('click', () => {
        if (hamburgerBtn.classList.contains('open')) {
            header.classList.remove('open-menu');
            headerWrap.classList.remove('open-menu');
            hamburgerBtn.classList.remove('open');
            body.classList.remove('open-menu-mobile');
            html.classList.remove('ovfw-hid-nav-mob');
        } else {
            heightMenuMobile();
            header.classList.add('open-menu');
            headerWrap.classList.add('open-menu');
            hamburgerBtn.classList.add('open');
            body.classList.add('open-menu-mobile');
            html.classList.add('ovfw-hid-nav-mob');
        }
    });

    // Chiusura tasto ESC
    document.addEventListener('keyup', (evt) => {
        if (evt.code === 'Escape') {
            if (!hamburgerBtn.classList.contains('open')) return;

            header.classList.remove('open-menu');
            headerWrap.classList.remove('open-menu');
            hamburgerBtn.classList.remove('open');
            body.classList.remove('open-menu-mobile');
            html.classList.remove('ovfw-hid-nav-mob');
        }
    });
};

/**
 *  Funzione di apertura del submenu
 *
 *  @return {void}
 */
const openSubMenu = (el) => {
    el.classList.add('open');
    headerWrap.classList.add('open-submenu');

    if (window.innerWidth >= 1140) {
        el.querySelector(':scope > .dropdown-menu').style.height = '';
    } else {
        let heightSubmenu = 0;
        let elementsInSub = el.querySelectorAll(':scope > .dropdown-menu > li');

        elementsInSub.forEach((element) => {
            heightSubmenu = heightSubmenu + element.offsetHeight;
        });

        el.querySelector(':scope > .dropdown-menu').style.height =
            heightSubmenu + 'px';
    }
};

/**
 *  Funzione di chiusura del submenu
 *
 *  @return {void}
 */
const closeSubMenu = (el) => {
    el.classList.remove('open');
    headerWrap.classList.remove('open-submenu');

    if (window.innerWidth >= 1140) return;

    el.querySelector(':scope > .dropdown-menu').style.height = '';
};

/**
 *  Funzione di chiusura di tutti i submenu
 *
 *  @return {void}
 */
const closeAllSubMenu = () => {
    linksWithSubMenu.forEach((el) => {
        closeSubMenu(el);
    });
};

/**
 *  Funzione per la gestione dell'apertura/chiusura dei submenu
 *
 *  @return {void}
 */
const manageSubMenu = () => {
    const iconDropdown =
        '<div class="submenu-indicator"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icon icons-open-down"><use xlink:href="' +
        templateUrl +
        '/assets/build/spritemap.svg#ico_arrow"></use></svg></div>';
    // '<div class="submenu-indicator"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icon icons-open-down"><use xlink:href="../../public/assets/build/spritemap.svg#ico_arrow"></use></svg></div>';
    for (let i = 0; i < linksWithSubMenu.length; ++i) {
        // Add icon dropdown
        linksWithSubMenu[i].innerHTML =
            linksWithSubMenu[i].innerHTML + iconDropdown;

        // START - EventListener Navbar expanded
        linksWithSubMenu[i].addEventListener('click', (evt) => {
            if (window.innerWidth < 1140) return;

            // evt.preventDefault();

            if (linksWithSubMenu[i].classList.contains('open')) {
                closeSubMenu(linksWithSubMenu[i]);
            } else {
                closeAllSubMenu();
                openSubMenu(linksWithSubMenu[i]);
            }
        });

        // Funzioni per la gestione dell'open al mouseover
        // linksWithSubMenu[i].addEventListener('mouseover', () =>
        // {
        //     if (window.innerWidth < 1140) return;

        //     openSubMenu(linksWithSubMenu[i]);
        // });

        // linksWithSubMenu[i].addEventListener('mouseleave', () =>
        // {
        //     if (window.innerWidth < 1140) return;

        //     closeSubMenu(linksWithSubMenu[i]);
        // });
        // END - EventListener Navbar expanded

        // START - EventListener Navbar compressed
        linksWithSubMenu[i]
            .querySelector('.dropdown-toggle')
            .addEventListener('click', (evt) => {
                if (window.innerWidth >= 1140) return;

                evt.preventDefault();

                if (!linksWithSubMenu[i].classList.contains('open')) {
                    openSubMenu(linksWithSubMenu[i]);
                } else {
                    closeSubMenu(linksWithSubMenu[i]);
                }
            });

        linksWithSubMenu[i]
            .querySelector('.submenu-indicator')
            .addEventListener('click', (evt) => {
                if (linksWithSubMenu[i].classList.contains('open')) {
                    closeSubMenu(linksWithSubMenu[i]);
                } else {
                    openSubMenu(linksWithSubMenu[i]);
                }
            });
        // END - EventListener Navbar compressed
    }
};

/**
 *  Funzione per calcolo altezza menu mobile
 *
 *  @return {void}
 */
const heightMenuMobile = () => {
    let wHeight = window.innerHeight;
    let wWidth = window.innerWidth;
    let offsetTopElements = 0;

    var topbar = document.querySelector('#top-bar');

    var topbarHeight = topbar ? topbar.offsetHeight : 0;

    if (wWidth < 1140) {
        if (body.classList.contains('scroll-detect')) {
            offsetTopElements = document.querySelector(
                'header .header-container'
            ).offsetHeight;
        } else {
            offsetTopElements =
                topbarHeight +
                document.querySelector('header .header-container').offsetHeight;
        }

        menuContainer.style.height = wHeight - offsetTopElements + 'px';
    } else {
        menuContainer.style.height = '';
    }
};

/**
 *  Funzione di init per tutte le funzioni del componente Header
 *
 *  @return {void}
 */
const initHeader = () => {
    manageMenuMobile();
    manageSubMenu();
    heightMenuMobile();
    manageSearchComponent();

    window.addEventListener('resize', () => {
        closeAllSubMenu();
        manageSearchComponent();
        heightMenuMobile();
    });

    document.addEventListener('keydown', (evt) => {
        if (evt.key === 'Escape') {
            closeAllSubMenu();
        }
    });
};

export default initHeader;

//--------------------------------------------------------------------//
